module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-helmet/~/core-js/modules/_a-function.js
// module id = 929
// module chunks = 0